/**
 * Helper functions for role and group access checks
 */

/**
 * Check if user is admin
 */
export const isAdmin = user => {
  if (!user || !user.role) {
    return false;
  }
  const role = String(user.role).trim().toLowerCase();
  return role === 'admin';
};

/**
 * Check if user is owner
 */
export const isOwner = user => {
  if (!user || !user.role) {
    return false;
  }
  const role = String(user.role).trim().toLowerCase();
  return role === 'owner';
};

/**
 * Check if user is admin or owner
 */
export const isAdminOrOwner = user => {
  return isAdmin(user) || isOwner(user);
};

/**
 * Check if user has access to any of the specified groups
 */
export const hasGroupAccess = (user, groups, groupIds) => {
  // Admin and owner bypass group checks
  if (isAdminOrOwner(user)) {
    return true;
  }

  // Check if user has any of the required groups
  const userGroupIds = groups.map(g =>
    typeof g === 'string' ? g : g.group_id || g.id
  );

  // If groupIds is a single string, convert to array
  const requiredGroupIds = Array.isArray(groupIds) ? groupIds : [groupIds];

  return requiredGroupIds.some(id => userGroupIds.includes(id));
};

/**
 * Get array of user's group IDs
 */
export const getGroupIds = groups => {
  return groups.map(g => (typeof g === 'string' ? g : g.group_id || g.id));
};

/**
 * Get array of user's group names
 */
export const getGroupNames = groups => {
  return groups.map(g =>
    typeof g === 'string' ? g : g.group_name || g.name || g.group_id || g.id
  );
};
